<!--
  文件描述：无缝滚动组件
-->
<template>
  <!-- <div class=""> -->
  <!-- <div class="page-example3" style="">
      <vue-seamless-scroll :data="listData" :class-option="defaultOption">
        <ul class="ul-scoll">
          <div v-for="(item, index) in listData" :key="index" style="position: relative;">
            <div class="title">{{ item.title }}：</div>
          </div>
        </ul>
      </vue-seamless-scroll>
    </div> -->
  <div id="mar" class="rx-sc">
    <!--主div分三部分，图标，系统公告名字，展示区域-->
    <div class="header">
      <!--图标-->
      <img class="w20 mr10" style="margin-top: -1px" src="@/assets/img/notice.png" />
      <!-- <span class="announcement">系统公告：</span>  -->
    </div>
    <!--公告展示块-->
    <div id="PackagingShell" class="PackagingShell">
      <!--主题内容，展示内容区域-->
      <div id="viewBox" style="height: 42px">
        <!--文本主体-->
        <span id="marquee">{{ text }}</span>
        <!--文本副本，实现无缝滚动-->
        <span id="transcript" />
      </div>
      <!--隐藏块，用于获取展示文本宽度-->
      <div id="hide">{{ text }}</div>
    </div>
  </div>
  <!-- <div class="animate_box">
      <span class="animate" v-for="(item, index) in listData" :key="index">{{ item.title }}</span>
    </div> -->
  <!-- </div> -->
</template>

<script>
// import vueSeamlessScroll from 'vue-seamless-scroll'
import { publicAdministration } from "@/api/statistics";
export default {
  name: "Example3",
  components: {
    // vueSeamlessScroll
  },
  data() {
    // 这里存放数据
    return {
      // newsList: [{
      //   'title': '暂无公告'
      // }, {
      //   'title': '是啊死啊是啊师弟奥术'
      // }],
      listData: [],
      noticeList: [],
      text: "", // 内容
      textWidth: 0, // 字符长度
      isScroll: false // 是否滚动
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.publicAdministrations();
    // this.init()
  },
  updated() {
    this.move();
  },
  // 方法集合
  methods: {
    publicAdministrations() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(225, 225, 225, 0.7)"
      });
      publicAdministration({})
        .then(res => {
          if (res.data.length > 0) {
            for (var i = 0; i < res.data.length; i++) {
              var obj = {};
              obj.text = res.data[i].content;
              obj.line = 2;
              if (!this.noticeList[0]) {
                this.noticeList[0] = { title: res.data[i].content };
              } else {
                this.noticeList[0].title =
                  this.noticeList[0].title +
                  "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" +
                  res.data[i].content;
              }
            }

            this.listData = this.noticeList;

            this.text = this.noticeList[0].title.replaceAll("\n", "\xa0\xa0\xa0\xa0\xa0\xa0");
          } else {
            this.text = "暂无公告";
          }
          loading.close();
          // this.move()
        })
        .catch(() => {
          loading.close();
        });
      // batchPay()
    },
    move() {
      // 首先获取整个内容的宽度,(展示内容会超出隐藏,无法通过获取盒子宽度取到实际的内容宽度)
      // 所以专门造了一个 div 块来放内容,隐藏起来 (无法用根据字体内容来计算宽度的方法,存在误差,当内容较多
      // 的时候误差会相对较大)
      const width = document.getElementById("hide").getBoundingClientRect().width;
      // 获取展示块盒模型宽度
      const BoxWidth = document.getElementById("PackagingShell").offsetWidth;
      // 获取内容展示宽
      const viewBox = document.getElementById("viewBox");
      // 判断内容是否超长
      if (BoxWidth - width < 0) {
        // 内容超长,则获取抄本元素
        const transcript = document.getElementById("transcript");
        // 抄本元素内容填充
        transcript.innerText = this.text;
        // 设定抄本和主题之间的间距
        transcript.style.marginLeft = "200px";
      } else {
        // 没有超长则return,不做任何操作
        return;
      }
      // 设置初始位移距离
      let distance = 0;
      // 移动函数,通过定时器实现
      setInterval(function () {
        // 位移内用记录是是递减,此处的 1 控制移动变量 s
        distance = distance - 1;
        // 判断是否整个内容移动完
        if (-distance >= width) {
          // 若移动完,则重新设定位移值,此处赋值200是正好把 上面设置的块间距  200px 也加入移动范围,实现移动完无缝跳转
          distance = 200;
        }
        // 实时设置位移距离
        viewBox.style.transform = "translateX(" + distance + "px)";
      }, 27); // 移动时间间隔t   s和t 共同决定移动速度
    }
    // 更新的时候运动
  }
};
</script>

<style scoped lang="scss">
//@import url(); 引入公共css类
// .seamless-warp2 {
//     overflow: hidden;
//     height: 105px;
//     width: 100%;
//     ul.item {
//         width: 100%;
//         li {
//             float: left;
//             margin-right: 10px;
//         }
//     }
// }
// .page-example3{
//     width: 100%;
//     height: 50px;
//     overflow: hidden;
//     ul {
//       padding-left: 0;
//     }
//     .ul-scoll{
//         li{
//           width: 100%;
//           display: inline-block;
//             margin: 6px;
//             padding: 5px;
//         }
//     }
// }
// .animate_box {
//   width: 400px;
//   overflow: hidden;
// }
// .animate {
//     color: rgba(0,0,0,.65);
//     display: inline-block;
//     white-space: nowrap;
//     // -webkit-animation: wordsLoop-data-v-53a69796 30s linear infinite normal;
//     animation: wordsLoop-data-v-53a69796 30s linear infinite normal;
// }

#mar {
  width: 100%;
  /*系统公告字体颜色*/
  .announcement {
    color: #ff4786;
  }
  height: 39px;
  line-height: 45px;
  /*公告滚动盒子样式*/
  .PackagingShell {
    width: calc(100% - 40px); /*滚动部分宽度*/
    overflow: hidden; /*超出部分隐藏*/
    font-size: 14px;
    color: #111;
  }
  /*主题内容块设置*/
  #viewBox {
    /*设置内容框不可换行,确保两个div块始终在同一行*/
    white-space: nowrap;
  }
  /*内容块设置*/
  #marquee {
    /*设置内容块不可换行*/
    white-space: nowrap;
    color: #5a5e66;
  }
  /*获取宽度的块，用z-index隐藏*/
  #hide {
    position: absolute;
    z-index: -999;
    top: -9999px;
    white-space: nowrap;
  }
  /*浮动设置和图片设置*/
  .header {
    // float: left;
    font-size: 14px;
    > img {
      vertical-align: middle;
    }
  }
}
</style>
